import { Routes } from '@angular/router';

export const APP_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/auth-steps/auth-steps/auth-steps.component').then(
        c => c.AuthStepsComponent
      ),
    title: 'Qantas Roadside',
  },
  {
    path: 'geo',
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/geo-page/geo-page/geo-page.component').then(
        c => c.GeoPageComponent
      ),
    title: 'Qantas GEO',
  },
  {
    path: 'confirmation',
    pathMatch: 'full',
    loadComponent: () =>
      import('./components/sms/sms.component').then(m => m.SmsComponent),
    title: 'CIS/Confirmation',
  },
  {
    path: 'tracker',
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/tracker/tracker/tracker.component').then(
        m => m.TrackerComponent
      ),
    title: 'Qantas Tracker',
  },
  {
    path: '**',
    redirectTo: '/',
  },
];
